// auth
const AuthTypes = {
  AUTH_CLEAR_ERRORS: "AUTH_CLEAR_ERRORS",
  AUTH_CLEAR_RESULT: "AUTH_CLEAR_RESULT",
  AUTH_GET_ERRORS: "AUTH_GET_ERRORS",
  AUTH_SET_LOADING: "AUTH_SET_LOADING",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  RESET_PASSWORD: "RESET_PASSWORD",
  SEND_OTP: "SEND_OTP",
  SET_CURRENT_USER: "SET_CURRENT_USER",
  REGISTER_CSV: "REGISTER_CSV",
  CHECK_SESSION: "CHECK_SESSION",
  TOKEN_LOADING: "TOKEN_LOADING",
  TOKEN_FOUND: "TOKEN_FOUND",
  ALL_UPDATE: "ALL_UPDATE",
  ADD_UPDATE: "ADD_UPDATE"
};

const UserTypes = {
  ADD_PHOTO: "ADD_PHOTO",
  ALL_USER_INPUTS_DYNAMIC: "ALL_USER_INPUTS_DYNAMIC",
  ALL_USER_INPUTS: "ALL_USER_INPUTS",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  DELETE_FACE: "DELETE_FACE",
  DELETE_USER: "DELETE_USER",
  GET_AWS_USERS: "GET_AWS_USERS",
  GET_USER_CALENDAR_DATA: "GET_USER_CALENDAR_DATA",
  GET_USER_DETAIL: "GET_USER_DETAIL",
  GET_USERS_FOR_ACCESS: "GET_USERS_FOR_ACCESS",
  GET_USERS: "GET_USERS",
  GET_ALL_USERS_IMAGES: "GET_ALL_USERS_IMAGES",
  USER_CLEAR_ERRORS: "USER_CLEAR_ERRORS",
  USER_CLEAR_RESULT: "USER_CLEAR_RESULT",
  USER_GEO_FENCE: "USER_GEO_FENCE",
  USER_GET_ERRORS: "USER_GET_ERRORS",
  USER_RESET_PASSWORD: "USER_RESET_PASSWORD",
  USER_SET_LOADING: "USER_SET_LOADING",
  USER_UNMOUNT: "USER_UNMOUNT",
  USER_WISE_ATTEND_INPUT: "USER_WISE_ATTEND_INPUT",
  GEO_ACTIVE_RESTRICT: "GEO_ACTIVE_RESTRICT",
  ASSIGN_RULE_TO_USER: "ASSIGN_RULE_TO_USER",
  EDIT_USER: "EDIT_USER",
  SHIFT_CHANGE: "SHIFT_CHANGE",
  SHIFT_SET_LOADING: "SHIFT_SET_LOADING",
  SHIFT_CLEAR_ERROR: "SHIFT_CLEAR_ERROR",
  SHIFT_CLEAR_RESULT: "SHIFT_CLEAR_RESULT",
  SHIFT_GET_ERRORS: "SHIFT_GET_ERRORS",
  SHIFT_REGISTER_CSV: "SHIFT_REGISTER_CSV",
  ADD_LOCATION_TO_USER_LOADING: "ADD_LOCATION_TO_USER_LOADING",
  ADD_LOCATION_TO_USER: "ADD_LOCATION_TO_USER",
  DELETE_DEVICE: "DELETE_DEVICE",
  ADD_DEVICE_SET_LOADING: "ADD_DEVICE_SET_LOADING",
  ADD_DEVICE: "ADD_DEVICE",
  GET_DEVICE: "GET_DEVICE"
};

const RuleTypes = {
  CREATE_RULE: "CREATE_RULE",
  DELETE_RULE: "DELETE_RULE",
  GET_RULES: "GET_RULES",
  RULE_ACTIVATE: "RULE_ACTIVATE",
  RULE_CLEAR_ERRORS: "RULE_CLEAR_ERRORS",
  RULE_CLEAR_RESULT: "RULE_CLEAR_RESULT",
  RULE_CREATE_GET_ERRORS: "RULE_CREATE_GET_ERRORS",
  RULE_GET_ERRORS: "RULE_GET_ERRORS",
  RULE_SET_CREATE_LOADING: "RULE_SET_CREATE_LOADING",
  RULE_SET_LOADING: "RULE_SET_LOADING",
  RULE_UNMOUNT: "RULE_UNMOUNT"
};

const LocationTypes = {
  CREATE_LOCATION: "CREATE_LOCATION",
  GET_LOCATIONS: "GET_LOCATIONS",
  LOCATION_CLEAR_ERRORS: "LOCATION_CLEAR_ERRORS",
  LOCATION_CLEAR_RESULT: "LOCATION_CLEAR_RESULT",
  LOCATION_GET_ERRORS: "LOCATION_GET_ERRORS",
  LOCATION_SET_CREATE_LOADING: "LOCATION_SET_CREATE_LOADING",
  LOCATION_SET_LOADING: "LOCATION_SET_LOADING",
  LOCATION_UNMOUNT: "LOCATION_UNMOUNT"
};

const HolidayTypes = {
  ADD_HOLIDAY_LIST: "ADD_HOLIDAY_LIST",
  GET_HOLIDAY: "GET_HOLIDAY",
  HOLIDAY_CLEAR_ERRORS: "HOLIDAY_CLEAR_ERRORS",
  HOLIDAY_CLEAR_RESULT: "HOLIDAY_CLEAR_RESULT",
  HOLIDAY_GET_ERRORS: "HOLIDAY_GET_ERRORS",
  HOLIDAY_SET_CREATE_LOADING: "HOLIDAY_SET_CREATE_LOADING",
  HOLIDAY_SET_LOADING: "HOLIDAY_SET_LOADING",
  HOLIDAY_UNMOUNT: "HOLIDAY_UNMOUNT"
};

const AttendanceTypes = {
  ADD_DAILY_MISSING_ATTENDANCE: "ADD_DAILY_MISSING_ATTENDANCE",
  ADD_DAILY_SINGLE_MISSING_ATTENDANCE:
    "ADD_DAILY_SINGLE_MISSING_ATTENDANCE",
  ATTENDANCE_CLEAR_ERRORS: "ATTENDANCE_CLEAR_ERRORS",
  ATTENDANCE_CLEAR_RESULT: "ATTENDANCE_CLEAR_RESULT",
  ATTENDANCE_GET_ERRORS: "ATTENDANCE_GET_ERRORS",
  ATTENDANCE_SET_LOADING: "ATTENDANCE_SET_LOADING",
  ATTENDANCE_UNMOUNT: "ATTENDANCE_UNMOUNT",
  DAILY_ATT_INPUTS: "DAILY_ATT_INPUTS",
  GET_ATTENDANCE_SHEET: "GET_ATTENDANCE_SHEET",
  UPDATE_SHIFT_SHEET: "UPDATE_SHIFT_SHEET",
  GET_DAILY_ATTENDANCE: "GET_DAILY_ATTENDANCE",
  GET_DAILY_DEPARTMENT_ATTENDANCE: "GET_DAILY_DEPARTMENT_ATTENDANCE",
  SHEET_INPUTS: "SHEET_INPUTS",
  GET_SHIFT_SHEET: "GET_SHIFT_SHEET",
  GET_ATTENDANCE_DYNAMIC_SHEET: "GET_ATTENDANCE_DYNAMIC_SHEET"
};

const CanteenTypes = {
  CANTEEN_CLEAR_ERRORS: "CANTEEN_CLEAR_ERRORS",
  CANTEEN_CLEAR_RESULT: "CANTEEN_CLEAR_RESULT",
  CANTEEN_GET_ERRORS: "CANTEEN_GET_ERRORS",
  CANTEEN_SET_LOADING: "CANTEEN_SET_LOADING",
  CANTEEN_UNMOUNT: "CANTEEN_UNMOUNT",
  DAILY_ATT_INPUTS: "DAILY_ATT_INPUTS",
  GET_CANTEEN_SHEET: "GET_CANTEEN_SHEET",
  GET_DAILY_CANTEEN: "GET_DAILY_CANTEEN",
  CREATE_CANTEEN_RULE: "CREATE_CANTEEN_RULE",
  CREATE_CANTEEN_SET_LOADING: "CREATE_CANTEEN_SET_LOADING",
  GET_CANTEEN_RULE: "GET_CANTEEN_RULE",
  SHEET_INPUTS: "SHEET_INPUTS"
};

const DashboardTypes = {
  GET_DAILY_ATT_DASHBOARD: "GET_DAILY_ATT_DASHBOARD",
  GET_DAILY_GOOGLE_MAP: "GET_DAILY_GOOGLE_MAP",
  DASHBOARD_CLEAR_ERRORS: "DASHBOARD_CLEAR_ERRORS",
  DASHBOARD_CLEAR_RESULT: "DASHBOARD_CLEAR_RESULT",
  DASHBOARD_GET_ERRORS: "DASHBOARD_GET_ERRORS",
  DASHBOARD_SET_LOADING: "DASHBOARD_SET_LOADING",
  DASHBOARD_UNMOUNT: "DASHBOARD_UNMOUNT"
};

const AccessTypes = {
  ACCESS_CLEAR_ERRORS: "ACCESS_CLEAR_ERRORS",
  ACCESS_CLEAR_RESULT: "ACCESS_CLEAR_RESULT",
  ACCESS_GET_ERRORS: "ACCESS_GET_ERRORS",
  ACCESS_INPUT: "ACCESS_INPUT",
  ACCESS_SET_CREATE_LOADING: "ACCESS_SET_CREATE_LOADING",
  ACCESS_SET_LOADING: "ACCESS_SET_LOADING",
  ACCESS_UNMOUNT: "ACCESS_UNMOUNT",
  ADD_ACCESS: "ADD_ACCESS",
  ALL_INPUTS: "ALL_INPUTS",
  CREATE_ACCESS: "CREATE_ACCESS",
  DELETE_ACCESS: "DELETE_ACCESS",
  GET_ALL_ACCESS: "GET_ALL_ACCESS",
  GET_EMPLOYEE_ACCESS: "GET_EMPLOYEE_ACCESS",
  SELECTED_MODULE_ACCESS: "SELECTED_MODULE_ACCESS"
};

const ReportingTypes = {
  GET_ATTENDANCE_SHEET_REPORTS: "GET_ATTENDANCE_SHEET_REPORTS",
  GET_REPORTING_EMPLOYEES_BY_LOCATION_ID:
    "GET_REPORTING_EMPLOYEES_BY_LOCATION_ID",
  GET_REPORTING_MANAGERS: "GET_REPORTING_MANAGERS",
  REPORTINGS_CLEAR_ERRORS: "REPORTINGS_CLEAR_ERRORS",
  REPORTINGS_CLEAR_RESULT: "REPORTINGS_CLEAR_RESULT",
  REPORTINGS_GET_ERRORS: "REPORTINGS_GET_ERRORS",
  REPORTINGS_SET_CREATE_LOADING: "REPORTINGS_SET_CREATE_LOADING",
  REPORTINGS_SET_LOADING: "REPORTINGS_SET_LOADING",
  SHEET_INPUTS: "SHEET_INPUTS"
};

const HrTypes = {
  ADD_DEPARTMENT_DESIGNATION_SUCCESS:
    "ADD_DEPARTMENT_DESIGNATION_SUCCESS",
  ADD_REIMBURSEMENT: "ADD_REIMBURSEMENT",
  ADD_REPORTING_MANAGERS: "ADD_REPORTING_MANAGERS",
  GET_ALL_REIMBURSEMENT: "GET_ALL_REIMBURSEMENT",
  GET_DESIGNATION: "GET_DESIGNATION",
  HANDLE_REIMBURSEMENT_ERROR: "HANDLE_REIMBURSEMENT_ERROR",
  HANDLE_REIMBURSEMENT_SUCCESS: "HANDLE_REIMBURSEMENT_SUCCESS",
  HR_CLEAR_ERRORS: "HR_CLEAR_ERRORS",
  HR_CLEAR_RESULT: "HR_CLEAR_RESULT",
  HR_GET_ERRORS: "HR_GET_ERRORS",
  HR_INPUTS: "HR_INPUTS",
  HR_SET_CREATE_LOADING: "HR_SET_CREATE_LOADING",
  HR_SET_LOADING: "HR_SET_LOADING",
  HR_UNMOUNT: "HR_UNMOUNT",
  REIMBURSEMENT_SET_LOADING: "REIMBURSEMENT_SET_LOADING",
  REIMBURSEMENT_UNMOUNT: "REIMBURSEMENT_UNMOUNT",
  GET_DEPARTMENT: "GET_DEPARTMENT",
  GET_REPORTING_MANAGERS: "GET_REPORTING_MANAGERS",
  APPLY_LEAVE: "APPLY_LEAVE",
  MY_APPLIED_LEAVE: "MY_APPLIED_LEAVE",
  GET_ALL_LEAVE: "GET_ALL_LEAVE",
  ALL_MISSING_ATTENDANCE_LIST: "ALL_MISSING_ATTENDANCE_LIST",
  TAKE_ATTENDANCE_ACTION: "TAKE_ATTENDANCE_ACTION",
  GET_ZONE: "GET_ZONE"
};

const QueryTypes = {
  ADD_QUERY_COMMENT: "ADD_QUERY_COMMENT",
  ALL_QUERY_INPUTS: "ALL_QUERY_INPUTS",
  ADD_QUERY: "ADD_QUERY",
  GET_ALL_QUERIES: "GET_ALL_QUERIES",
  GET_QUERY_DETAILS: "GET_QUERY_DETAILS",
  QUERY_CLEAR_ERRORS: "QUERY_CLEAR_ERRORS",
  QUERY_CLEAR_RESULT: "QUERY_CLEAR_RESULT",
  QUERY_ERRORS: "QUERY_ERRORS",
  QUERY_SET_CREATE_LOADING: "QUERY_SET_CREATE_LOADING",
  QUERY_SET_LOADING: "QUERY_SET_LOADING",
  COMMENT_SET_CREATE_LOADING: "COMMENT_SET_CREATE_LOADING"
};

const DprFormTypes = {
  ADD_DPR: "ADD_DPR",
  ALL_DPR_INPUTS: "ALL_DPR_INPUTS",
  DPR_CLEAR_ERRORS: "DPR_CLEAR_ERRORS",
  DPR_CLEAR_RESULT: "DPR_CLEAR_RESULT",
  DPR_ERRORS: "DPR_ERRORS",
  DPR_SET_CREATE_LOADING: "DPR_SET_CREATE_LOADING",
  DPR_SET_LOADING: "DPR_SET_LOADING",
  GET_ALL_DPR: "GET_ALL_DPR",
  GET_DPR_DETAILS: "GET_DPR_DETAILS"
};
export {
  CanteenTypes,
  AuthTypes,
  UserTypes,
  RuleTypes,
  AccessTypes,
  LocationTypes,
  AttendanceTypes,
  DashboardTypes,
  HolidayTypes,
  HrTypes,
  ReportingTypes,
  QueryTypes,
  DprFormTypes
};
